import type { ToteEngagementModeWithAwaiting } from '../types'
import { ToteCardMode } from '../types'

// For compatibility reasons, until we refactor the code to use the new types
export const SCREEN_MODES = ToteCardMode

export interface ActionProps {
  icon?: JSX.Element
  text: string
}

export const ACTION_DATA: Record<ToteEngagementModeWithAwaiting, ActionProps> =
  {
    affirmative: {
      text: 'I know what to do'
    },
    assistive: {
      text: 'I may need help'
    },
    awaiting: {
      text: 'Awaiting response'
    }
  }
